export default {
  data() {
    return {
      fieldWidthArr: []
    }
  },
  methods: {
    initColumn(tableName) {
      if (tableName) {
        _api
          .get('/base/system-table-config/index', { table: tableName })
          .then(res => {
            if(res.code != 0){
              this.$message.error(res.message);
              return false;
            }

            this.$set(this.fieldWidthArr, tableName, res.data.list)
          });
      }
    },
    updateColumn(tableName, column, width) {
      if (tableName) {
        let params = {
          table: tableName,
          column,
          width
        }
        _api
          .post('/base/system-table-config/update', params)
          .then(res => {
            if(res.code != 0){
              this.$message.error(res.message);
              return false;
            }
          });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table/column.js